var module = angular.module('octopusApp.infrastructure');

module.controller('AsyncConfirmDialogController', function ($scope, busy, options, $uibModalInstance, $timeout) {
  var isWorking = $scope.isWorking = busy.create();
  $scope.options = options;

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.execute = function () {
    $scope.options.execute({
      busy: isWorking,
      dismiss: function () {
        $uibModalInstance.close(true);
      }
    });
  };

  if ($scope.options.error) {
    $timeout(function () {
      isWorking.error = $scope.options.error;
    });
  }
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/controllers/async_confirm_dialog_controller.js
// module id = 2770954189628825
// module chunks = 1